export default __webpack_public_path__ + "static/prost-psor-plus-herbal-guarantee-fb9aa3acf3eadbef8c0e5a53cb3e8d7e.jpg";